module.exports = __webpack_public_path__ + "media/images/spinner-778ae9cd0386dfea50eed920bb545a2a.gif";